import html2canvasFixSvg from 'html2canvas-fixsvg'
import { useState } from 'react'
import { createPortal } from 'react-dom'
import EventEmitter, {
  DID_MOUNT_COMPONENT,
} from '../../../../../helpers/EventEmitter'
import { debounce } from '../../../../../helpers/common'
import { CLASS_HIDE_TABLE_PDF } from '../../../../../utils/common'
import { HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING } from './constant'
import { cloneNodeIncludeContent, getPdfHeightImage } from './helper'

const removeOldContainer = (id) => {
  const oldContainer = document.getElementById(id)
  if (oldContainer) {
    document.body.removeChild(oldContainer)
  }
}

const convertToImg = (el, callback) => {
  const { width: widthCut, height: heightCut } = el.getBoundingClientRect()
  const ratio = 2
  const configCanvas = {
    allowTaint: true,
    useCORS: true,
    removeContainer: true,
    logging: false,
    scale: ratio,
    width: widthCut,
    height: heightCut,
    onclone: (document) => {
      Array.from(document.children[0].querySelectorAll('*')).forEach((e) => {
        if (e.tagName !== 'I' && e.parentNode?.tagName !== 'I') {
          e.setAttribute(
            'style',
            [
              'font-family: sans-serif !important',
              e.getAttribute('style') || '',
            ].join(';'),
          )
        } else {
          e.setAttribute(
            'style',
            [
              'font-family: fiingate !important',
              e.getAttribute('style') || '',
            ].join(';'),
          )
        }
      })
    },
  }

  const htmlToCanvas = html2canvasFixSvg

  htmlToCanvas(el, configCanvas)
    .then((canvas) => {
      const canvasExport = document.createElement('canvas')
      const contextExport = canvasExport.getContext('2d')
      canvasExport.width = widthCut * ratio
      canvasExport.height = heightCut * ratio
      contextExport.fillRect(0, 0, canvasExport.width, canvasExport.height)
      contextExport.drawImage(canvas, 0, 0)
      document.body.appendChild(canvasExport)
      const data = canvasExport.toDataURL('image/jpg')
      document.body.removeChild(canvasExport)

      callback({ data, width: widthCut, height: heightCut })
    })
    .catch((e) => {
      console.log(e)
    })
}

export const HtmlToImage = ({
  id,
  children,
  onDoneProcess,
  availableHeightPage = HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING,
}) => {
  const [container] = useState(() => {
    removeOldContainer(id)
    const containerEl = document.createElement('div')
    const pxOutOfScreen = '-100000px'
    containerEl.id = id
    containerEl.style.position = 'absolute'
    containerEl.style.left = pxOutOfScreen
    containerEl.style.top = pxOutOfScreen

    document.body.appendChild(containerEl)
    return containerEl
  })

  if (!EventEmitter.events.DID_MOUNT_COMPONENT?.length) {
    const onMountRechart = debounce(() => {
      EventEmitter.unsubscribe(DID_MOUNT_COMPONENT, onMountRechart)
      convertToImage()
    }, 100)
    EventEmitter.subscribe(DID_MOUNT_COMPONENT, onMountRechart)
  }

  const convertToImage = () => {
    if (container) {
      const trEl = Array.from(
        container.querySelector('tbody')?.querySelectorAll('tr') || [],
      )
      if (!trEl.length) {
        const callback = (data) => {
          onDoneProcess({ img: [data] })
        }
        convertToImg(container, callback)
      } else {
        const getNewContainer = () => {
          const newContainer = cloneNodeIncludeContent(container)
          newContainer.querySelector('tbody').innerHTML = ''
          const pxOutOfScreen = '-100000px'
          newContainer.style.position = 'absolute'
          newContainer.style.left = pxOutOfScreen
          newContainer.style.top = pxOutOfScreen
          document.body.appendChild(newContainer)
          return newContainer
        }
        const containers = []
        let currentAvailableHeightPage = availableHeightPage
        let currentTable = getNewContainer()
        trEl.forEach((tr, index) => {
          let tbody = currentTable.querySelector('tbody')
          tbody.appendChild(tr)
          const { width, height } = currentTable.getBoundingClientRect()
          if (getPdfHeightImage(width, height) > currentAvailableHeightPage) {
            tbody.removeChild(tr)
            if (index) {
              containers.push(currentTable)
            }
            currentAvailableHeightPage = HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING
            currentTable = getNewContainer()
            currentTable.querySelector('tbody').appendChild(tr)
          }
          if (index === trEl.length - 1) {
            containers.push(currentTable)
          }
        })
        const img = []
        const callback = (data) => {
          img.push(data)
          if (img.length === containers.length) {
            onDoneProcess({ img })
          }
        }
        containers.forEach((container, index) => {
          if (index) {
            Array.from(
              container.querySelectorAll(`.${CLASS_HIDE_TABLE_PDF}`) || [],
            ).forEach((el) => (el.style.display = 'none'))
          }
          convertToImg(container, callback)
          if (index === containers.length - 1) {
            container.remove()
          }
        })
      }
    }
  }

  return <>{children && createPortal(children, container)}</>
}
